import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateCommentaryOverview = api(async function updateCommentaryOverview({ title, content }) {
    return mutate(
        gql`
            mutation UpdateCommentaryOverview($title: String!, $content: String) {
                updateCommentaryOverview(title: $title, content: $content)
            }
        `,
        { title, content },
        { returns: "updateCommentaryOverview" }
    )
})
